//
//
//
//
//
//
//
//
//

export default {
  props: {
    tabs: {
      type: Array, default: () => []
    }
  },
  data () {
    return {
      switchate: 2 // 1为手机号验证码登录，2为手机号邮箱登录
    }
  },
  computed: {
    // 完整的域名
    fullDomain () {
      return this.$store?.state?.fullHost
    }
  },
  watch: {
    switchate (newV) {
      this.$emit('switch', newV)
      this.switchate = newV
    }
  },
  created () {
    this.switchate = (this.fullDomain?.includes('wikifx') ? 2 : 1)
  }
}
